import apiSkobo from "@/helpers/api/apiSkobo";

export const confidentialLogging_actions = {
  async logActivity(appConfidentialId, system, objectId, driveId, itemId, action, metadata) {
    if (import.meta.env.VITE_APP_DO_LOG_ACTIVITY == "true") {
      try {
        apiSkobo.post(`/appconfidentialfolder/${appConfidentialId}/log`, {
          system,
          action,
          objectId,
          driveId,
          itemId,
          metadata
        });
        // eslint-disable-next-line no-empty
      } catch {}
    }
  }
};
